import {CookieConsentProvider, GTMProvider, RedirectorProvider} from '@tnc/shared';
import {ReactNode} from 'react';
import {Provider} from 'react-redux';

import store from '@/lib/redux/store';

import {AppProvider} from '@/providers/components/appProvider';
import {AuthProvider} from '@/providers/components/authProvider';
import {AppFormProvider} from '@/providers/components/formProvider';
import {NotificationsProvider} from '@/providers/components/notificationsProvider';
import {ReactQueryClientProvider} from '@/providers/components/reactQueryClientProvider';

const COOKIE_BOT_ID = import.meta.env.VITE_COOKIE_BOT_ID || '';
const GTM_ID = import.meta.env.VITE_GTM_ID || '';

type GlobalProvidersPropsT = {
  children: ReactNode;
};

function GlobalProviders({children}: GlobalProvidersPropsT) {
  return (
    <>
      <ReactQueryClientProvider>
        {/* Analytics & Consent Providers */}
        <CookieConsentProvider cookieBotId={COOKIE_BOT_ID}>
          <GTMProvider gtmId={GTM_ID}>
            {/* Vendor Providers */}
            <Provider store={store}>
              <RedirectorProvider>
                {/* Global Providers */}
                <AuthProvider>
                  <AppProvider>
                    <NotificationsProvider>
                      <AppFormProvider>{children}</AppFormProvider>
                    </NotificationsProvider>
                  </AppProvider>
                </AuthProvider>
              </RedirectorProvider>
            </Provider>
          </GTMProvider>
        </CookieConsentProvider>
      </ReactQueryClientProvider>
    </>
  );
}

export default GlobalProviders;
